import { useEffect } from 'react';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Icon } from '@antimatterhq/ui/components/icon';
import { Text } from '@antimatterhq/ui/components/typography';
import { useNavigate } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import { useGetWorkspaceContext } from '@/hooks/workspace/useGetWorkspaceContext';

export default function Initialization() {
  const { data: workspaceContext, isPending } = useGetWorkspaceContext();
  const navigate = useNavigate();
  const { enableInitialHousekeepingCheck } = useFlags<FlagSet>();

  useEffect(() => {
    if (
      (!isPending && !!workspaceContext?.installationComplete) ||
      !enableInitialHousekeepingCheck
    ) {
      navigate('/');
    }
  }, [isPending, workspaceContext, navigate, enableInitialHousekeepingCheck]);

  return (
    <div className="flex h-screen w-full flex-col overflow-hidden">
      <div className="flex h-full w-full flex-col items-center justify-center">
        <Icon icon="lucide:shield-plus" className="h-24 w-24 text-gray-400" />
        <Spacer size="lg" />
        <Text size="lg" semiBold className="text-gray-500">
          Welcome to Security Lakehouse
        </Text>
        <Text className="max-w-[700px] text-center text-gray-500">
          Your organization’s security lakehouse has not been provisioned. Talk
          to your Databricks administrator to make sure they have completed the
          setup for your organization’s security lakehouse.
        </Text>
      </div>
    </div>
  );
}
